var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 27.4286C35.668 27.4286 40.4643 22.6323 40.4643 16.7143C40.4643 10.7963 35.668 6 29.75 6C23.832 6 19.0357 10.7963 19.0357 16.7143C19.0357 22.6323 23.832 27.4286 29.75 27.4286ZM37.25 30.1071H35.8521C33.9939 30.9609 31.9263 31.4464 29.75 31.4464C27.5737 31.4464 25.5145 30.9609 23.6479 30.1071H22.25C16.0391 30.1071 11 35.1462 11 41.3571V44.8393C11 47.0575 12.7997 48.8571 15.0179 48.8571H44.4821C46.7003 48.8571 48.5 47.0575 48.5 44.8393V41.3571C48.5 35.1462 43.4609 30.1071 37.25 30.1071Z",
    fill: "#717783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.9e9ea540c96631ac6eb86294709df681.svg";
export { ForwardRef as ReactComponent };